import React, { useState, useEffect, useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import { AppHeader } from '../../shared/components/AppComponents';
import { apiFetchJson } from '../../apiClient';
import './UserAdmin.css';

function UserAdmin({ user }) {
  const { instance } = useMsal();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUsers = useCallback(async () => {
    setLoading(true);
    try {
      const data = await apiFetchJson(instance, '/api/Users/summary');
      setData(data);
    } catch (err) { console.error('Failed to load users:', err); }
    setLoading(false);
  }, [instance]);

  useEffect(() => { loadUsers(); }, [loadUsers]);

  return (
    <div className="user-admin">
      <AppHeader title="Registered Users" user={user} />

      {loading && <div className="user-admin-loading">Loading...</div>}

      {data && (
        <>
          <div className="user-admin-summary">
            <span className="user-admin-count">{data.count}</span>
            <span className="user-admin-limit">/ {data.limit} users</span>
          </div>

          <div className="user-admin-bar">
            <div
              className="user-admin-bar-fill"
              style={{ width: `${(data.count / data.limit) * 100}%` }}
            />
          </div>

          <div className="user-admin-list">
            {(Array.isArray(data.users) ? data.users : (data.users?.$values || [])).map(u => (
              <div key={u.id} className="user-admin-card">
                <div className="user-admin-card-info">
                  <strong>{u.name}</strong>
                  <span className="user-admin-email">{u.email}</span>
                </div>
                <div className="user-admin-card-meta">
                  <span>Joined {new Date(u.joinedAt).toLocaleDateString('nb-NO')}</span>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default UserAdmin;
